'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode } from 'react';
import { cn } from '@src/utils/tailwind';
export const AlignItems = ['strech', 'center', 'start', 'end'] as const;
export const JustifyContent = ['center', 'start', 'end', 'around', 'evenly', 'between'] as const;
interface FlexProps {
  isColumn?: boolean;
  reverseInMobile?: boolean;
  alignItems: (typeof AlignItems)[number];
  justifyContent: (typeof JustifyContent)[number];
  gap?: number;
  flexWrap?: boolean;
  children: ReactNode;
}
export const Flex = props => {
  const $ = _c(21);
  const {
    isColumn,
    alignItems,
    justifyContent,
    reverseInMobile,
    gap,
    flexWrap: t0,
    children
  } = props;
  const flexWrap = t0 === undefined ? false : t0;
  const t1 = reverseInMobile && isColumn;
  const t2 = reverseInMobile && !isColumn;
  const t3 = alignItems === "center";
  const t4 = alignItems === "end";
  const t5 = alignItems === "strech";
  const t6 = alignItems === "start";
  const t7 = justifyContent === "center";
  const t8 = justifyContent === "end";
  const t9 = justifyContent === "start";
  const t10 = justifyContent === "around";
  const t11 = justifyContent === "evenly";
  const t12 = justifyContent === "between";
  let t13;
  if ($[0] !== flexWrap || $[1] !== isColumn || $[2] !== t1 || $[3] !== t10 || $[4] !== t11 || $[5] !== t12 || $[6] !== t2 || $[7] !== t3 || $[8] !== t4 || $[9] !== t5 || $[10] !== t6 || $[11] !== t7 || $[12] !== t8 || $[13] !== t9) {
    t13 = cn("flex flex-row", {
      "flex-col": isColumn,
      "flex-row lg:flex-col": t1,
      "flex-col lg:flex-row": t2,
      "items-center": t3,
      "items-end": t4,
      "items-stretch": t5,
      "items-start": t6,
      "justify-center": t7,
      "justify-end": t8,
      "justify-start": t9,
      "justify-around": t10,
      "justify-evenly": t11,
      "justify-between": t12,
      "flex-wrap": flexWrap
    });
    $[0] = flexWrap;
    $[1] = isColumn;
    $[2] = t1;
    $[3] = t10;
    $[4] = t11;
    $[5] = t12;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
    $[13] = t9;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  let t14;
  if ($[15] !== gap) {
    t14 = {
      gap
    };
    $[15] = gap;
    $[16] = t14;
  } else {
    t14 = $[16];
  }
  let t15;
  if ($[17] !== children || $[18] !== t13 || $[19] !== t14) {
    t15 = <div className={t13} style={t14}>{children}</div>;
    $[17] = children;
    $[18] = t13;
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  return t15;
};